import { FC } from 'react'

import { Container } from 'components/container'
import {
  Credits,
  CreditsItem,
  Foot,
  Footer,
  Head,
  NameList,
  Names,
  Role,
  Socials,
  Subtitle,
  Title,
  Top,
} from './styles'
import { IconFacebook } from 'components/icons/facebook'
import { IconYoutube } from 'components/icons/youtube'
import { IconInstagram } from 'components/icons/instagram'
import { IconTelegram } from 'components/icons/telegram'
import { Twitter } from '../header/icons/twitter'

type Props = {
  authors: Array<{
    title: string
    names: string[]
  }>
}

export const ChapterFooter: FC<Props> = ({ authors }) => (
  <Footer>
    <Container $mode="restricted">
      <Top>
        <Head>
          <Title>ГОЛОСА СМЕЛЫХ</Title>
          <Subtitle>
            Проект против гендерного насилия в&nbsp;Центральной Азии
          </Subtitle>

          <Socials>
            <li>
              <a
                href="http://facebook.com/currenttimetv"
                target="_blank"
                rel="noreferrer"
              >
                <IconFacebook />
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/CurrentTimeTv"
                target="_blank"
                rel="noreferrer"
              >
                <Twitter />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/user/currenttimetv"
                target="_blank"
                rel="noreferrer"
              >
                <IconYoutube />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/currenttime.tv/"
                target="_blank"
                rel="noreferrer"
              >
                <IconInstagram />
              </a>
            </li>
            <li>
              <a
                href="https://telegram.me/currenttime"
                target="_blank"
                rel="noreferrer"
              >
                <IconTelegram />
              </a>
            </li>
          </Socials>
        </Head>

        <Credits>
          {authors.map((item) => (
            <CreditsItem key={item.title}>
              <Role>{item.title}</Role>
              <Names>
                {item.names.length > 1 ? (
                  <NameList>
                    {item.names.map((name) => (
                      <li key={name}>{name}</li>
                    ))}
                  </NameList>
                ) : (
                  item.names
                )}
              </Names>
            </CreditsItem>
          ))}
        </Credits>
      </Top>

      <Foot>
        <p>
          Этот лонгрид финансируется Европейским Союзом в рамках проекта
          «Повышение устойчивости аудитории через достоверные истории»
          (CARAVAN), реализуемого Internews.
        </p>
        <p>
          Ответственность за его содержание лежит исключительно на проекте
          «Голоса смелых» и не обязательно отражает точку зрения Европейского
          Союза и Internews
        </p>
      </Foot>
    </Container>
  </Footer>
)
